import { Directive, HostListener } from '@angular/core';
import { windowService} from 'app/services';
import { SiteCatalystTriggerService} from 'app/services/site-catalyst-trigger.service';
@Directive({
  selector: '[scAutomaticCall]'
})
export class ScAutomaticCallDirective {

  private window: any;
  private s: any;

  constructor(
    private _window: windowService,
    private scTriggerService: SiteCatalystTriggerService,
  ) {
    this.window = _window.nativeWindow;
    this.s = _window.nativeWindow.s;
  }



  @HostListener('click', ['$event']) onClick() {
    let currElement = event.target as HTMLElement;
    let cssClasses = currElement.classList;
    let ddList = document.getElementsByClassName('sc-dropdown');
    // form selection
    if ((currElement.tagName.toLowerCase() == 'button' && currElement.getAttribute('type') && currElement.getAttribute('type').toLowerCase() == 'submit')
      || currElement.tagName.toLowerCase() == 'button' && cssClasses.contains('form-submit')) {
      this.scTriggerService.triggerFormSubmission(currElement);
    }
    // link click
    else if ((currElement.tagName.toLowerCase() == 'a' && !cssClasses.contains('.not-sc-link'))
      || (currElement.tagName.toLowerCase() == 'button' && cssClasses.contains('sc-link'))
      || (cssClasses.contains('sc-file-link') || (cssClasses.contains('textBold')))) {
      this.scTriggerService.triggerLinkClick(currElement);
    }
   
  }
}